// src/components/WordRow.js
import React from 'react';

const WordRow = ({ word, size = 'large', isCrowded = false, isVeryCrowded = false, extraClass = '', tileExtraClass = '', medal = null }) => {
    const length = word.length;

    // Adjust font size based on word length for responsiveness
    const getFontSizeClass = () => {
        if (size === 'small') {
            if (length > 12) return 'text-xs sm:text-sm';
            if (length > 10) return 'text-sm sm:text-base';
            if (length > 8) return 'text-base sm:text-lg';
            return 'text-lg sm:text-xl';
        }
        // large size for pyramid
        if (isVeryCrowded) {
            if (length > 9) return 'text-base sm:text-lg'; // Adjusted from text-lg sm:text-xl
            return 'text-lg sm:text-xl'; // Adjusted from text-xl sm:text-2xl
        }
        if (length > 9) return 'text-xl sm:text-2xl'; // Adjusted from text-2xl sm:text-3xl
        return 'text-2xl sm:text-3xl'; // Adjusted from text-3xl sm:text-4xl
    };

    const getTileSizeClass = () => {
        if (size === 'small') {
            if (length > 12) return 'w-6 h-6 sm:w-8 sm:h-8';
            if (length > 10) return 'w-7 h-7 sm:w-9 sm:h-9';
            return 'w-8 h-8 sm:w-10 sm:h-10';
        }
        // large size for pyramid
        if (isVeryCrowded) {
            if (length > 7) return 'w-6 h-6 sm:w-8 sm:h-8';   // 8+
            if (length > 5) return 'w-7 h-7 sm:w-9 sm:h-9';   // 6, 7
            return 'w-8 h-8 sm:w-10 sm:h-10';                  // <= 5
        }
        if (isCrowded) {
            if (length > 7)  return 'w-8 h-8 sm:w-11 sm:h-11';  // 8+ letters
            if (length > 5)  return 'w-8 h-8 sm:w-12 sm:h-12';  // 6, 7
            return 'w-9 h-9 sm:w-13 sm:h-13';                 // <= 5
        }
        if (length > 11) return 'w-8 h-8 sm:w-9 sm:h-9';    // 12, 13
        if (length > 9)  return 'w-8 h-8 sm:w-10 sm:h-10';  // 10, 11
        if (length > 7)  return 'w-9 h-9 sm:w-11 sm:h-11';  // 8, 9
        if (length > 5)  return 'w-9 h-9 sm:w-12 sm:h-12';  // 6, 7
        return 'w-10 h-10 sm:w-13 sm:h-13';                 // <= 5
    };

    const getSpacingClass = () => {
        if (isVeryCrowded) {
            return 'space-x-0.5 sm:space-x-0.5';
        }
        if (isCrowded) {
            if (length > 10) return 'space-x-0.5 sm:space-x-1';
            return 'space-x-1 sm:space-x-1';
        }
        if (length > 10) return 'space-x-0.5 sm:space-x-1';
        return 'space-x-1 sm:space-x-2';
    }

    return (
        <div className={`flex justify-center items-center ${getSpacingClass(word.length)} ${getFontSizeClass(word.length)} ${extraClass}`}>
            {word.split('').map((letter, index) => (
                <span 
                    key={index}
                    className={`font-bold uppercase flex items-center justify-center ${getTileSizeClass()} ${medal ? '' : 'bg-white dark:bg-dark-key-bg'} shadow-md rounded-md ${tileExtraClass}`}
                >
                    {letter}
                </span>
            ))}
        </div>
    );
};

export default WordRow;
